export default __webpack_public_path__ + "images/models/73f43911960f7550244e22af67b30e5b.usdz";